module.exports = __webpack_public_path__ + "img/case-logo-48.f4b15362.png";